import { render, staticRenderFns } from "./CalendarInfoButton.vue?vue&type=template&id=5f228aea"
import script from "./CalendarInfoButton.vue?vue&type=script&lang=js"
export * from "./CalendarInfoButton.vue?vue&type=script&lang=js"
import style0 from "./CalendarInfoButton.vue?vue&type=style&index=0&id=5f228aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports